import { useMemo } from 'react';

import { isMessageMeta, isMessagePersona, isMessagePost } from '@web/conversations/utils/guards';
import { Message as MessageType } from '@web/conversations/types/Message';

import { MessageMeta } from './MessageMeta/MessageMeta';
import { MessagePersona } from './MessagePersona/MessagePersona';
import { MessagePost } from './MessagePost/MessagePost';
import { MessagePostDeleted } from './MessagePostDeleted/MessagePostDeleted';

type Props = {
  message: MessageType;
  withHeader: boolean;
};

export const Message = ({ message, withHeader }: Props) =>
  useMemo(() => {
    if (isMessagePost(message)) {
      return message.isDeleted ? (
        <MessagePostDeleted message={message} withHeader={withHeader} />
      ) : (
        <MessagePost message={message} withHeader={withHeader} />
      );
    }
    if (isMessageMeta(message)) return <MessageMeta message={message} />;
    if (isMessagePersona(message)) return <MessagePersona message={message} />;
  }, [message, withHeader]);
